import React, { useRef, useEffect } from "react";
import * as d3 from 'd3';
import { select } from 'd3';
import axios from 'axios'
import { useQuery } from 'react-query'

const fetchData = async (statKey) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/stats/${statKey}`);
    // console.log(`${process.env.REACT_APP_API_HOST}/bc/stats/${statKey}`)
    return data;
}

function DataContainer(props) {
    const { CoreAreaWidth, SelectedPrevYear, SelectedNextYear, Color, statKey, menu } = props;
    const { data, error, isError, isLoading } = useQuery(['dataCoreArea', statKey], () => fetchData(statKey));
    const svgRef = useRef(null);
    // console.log(CoreAreaWidth, 'CoreAreaWidth')

    function preprocess(d) {
        for (let i of d) {
            i.value = +i.anals_value || NaN;
            i.year = new Date(i.years, 0);
        }
        return d;
    }

    const shadeColor = (color, percent) => {
        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);

        R = parseInt((R * (100 + percent)) / 100);
        G = parseInt((G * (100 + percent)) / 100);
        B = parseInt((B * (100 + percent)) / 100);

        R = R < 255 ? R : 255;
        G = G < 255 ? G : 255;
        B = B < 255 ? B : 255;

        var RR =
            R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
        var GG =
            G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
        var BB =
            B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

        // console.log('#' + RR + GG + BB, 'result');
        // setDarkenColor("#" + RR + GG + BB, "result");
        return "#" + RR + GG + BB;
    };

    const tcolor = Color, grey = '#DDD';
    const boxMargin = { w: 55, h: 45 }, axisMargin = 10;
    const divMargin = { w: 25, h: 25 };
    const mobileBox = { w: 250, h: 125 };
    const chartTitleH = 18;
    const lw = 1, ms = 5;
    
    function renderChartTs(data_, svg, CoreAreaWidth) {
        const rdata = preprocess(data_); // what if sdname doesn't exist?

        const sort_dict = {'강화도':0, '가로림만':1, '증도':2, '순천만':3, '낙동강하구':4, '군산시':5, '장흥군':6, '남해군':7, '거제시':8, '삼척시':9 };
        // const regions = [...new Set(rdata.map(i => i.lc_sclas))].sort();
        const regions = [...new Set(rdata.map(i => i.lc_sclas))].sort((a, b) => sort_dict[a] - sort_dict[b]);

        const divWidth = CoreAreaWidth - 25 * 2;
        const mobileView = CoreAreaWidth < 534 ? true : false;
        const divHeight = mobileView ? 2 * divMargin.h + regions.length * (mobileBox.h + boxMargin.h) - boxMargin.h : 200;
        // console.log(regions.length * (mobileBox.h + boxMargin.h), 'divHeight');

        svg.attr('width', divWidth)
            .attr('height', divHeight);
        
        if (mobileView) {
            const box = mobileBox;

            const yScale = d3.scaleLinear()
                .domain(d3.extent(data, d => d.value)).nice()
                .range([box.h, axisMargin]);
    
            const xScale = d3.scaleTime()
                .domain(d3.extent(data, d => d.year))
                .range([axisMargin, box.w]);

            for (let [i, region] of regions.entries()) {
                let coord_y = divMargin.h + (box.h + boxMargin.h) * i;
                
                svg.insert('text')
                    .text(region)
                    .attr('class', 'chartTitle')
                    .attr('x', divMargin.w)
                    .attr('y', coord_y);

                    const noTextArea = rdata.filter((element) => !isNaN(element.value)).map(element => element.lc_sclas);
                    // console.log(noTextArea)

                    if ( !noTextArea.includes(region) ) {
                        
                        svg.insert('text')
                            .text('데이터 없음')
                            .attr('class', 'noData')
                            .attr('x', divMargin.w + (box.w + boxMargin.w)*0.5 )
                            .attr('text-anchor', 'end')
                            .attr('y', (box.h + boxMargin.h)/2 )
                            .attr('dominant-baseline', 'central')
                            .style('fill', 'darkGrey');

                    }
                
                let chart = svg.append('g')
                    .attr('transform', `translate(${divMargin.w + 80}, ${coord_y - chartTitleH})`);
                
                chart.append('path')
                    .datum(rdata.filter(x => x.lc_sclas == region))
                    .attr('fill', 'none')
                    .attr('stroke', tcolor)
                    .attr('stroke-width', lw)
                    .attr('marker-start', 'url(#dot)')
                    .attr('marker-mid', 'url(#dot)')
                    .attr('marker-end', 'url(#dot)')
                    .attr('stroke-linecap', 'round')
                    .attr('d', d3.line()
                    .defined(d => !isNaN(d.value))
                    .x(d => xScale(d.year))
                    .y(d => yScale(d.value)));
                
                chart.append('g')
                    .selectAll('text')
                    .data(rdata.filter(x => x.lc_sclas == region))
                    .join('text')
                    .text(d => !isNaN(d.value) ? parseInt(d.value * 10) / 10 : '')
                    // .attr('class', 'timeSeriesValue')
                    // .attr('fill', (d, i) => {
                    //         const val = 50 - (.25 + (i / 2) * .75) * 100;
                    //         const resultColor = shadeColor(tcolor, val);
                    //         return resultColor;
                    //     })
                    .attr('fill', tcolor)
                    .attr('x', d => xScale(d.year))
                    .attr('y', d => yScale(d.value))
                    .attr('dy', -10)
                    .attr('text-anchor', 'middle');

                chart.append('g')
                    .attr('transform', `translate(0, ${box.h + axisMargin})`)
                    .attr('id', 'x')
                    .attr('class', 'scale')
                    .call(d3.axisBottom(xScale)
                    .ticks(d3.timeYear.every(1))
                    .tickSize(0)
                    .tickPadding(5)
                    );
            };
        } else { 
            const box = { w: (divWidth - 2 * divMargin.w - boxMargin.w * (regions.length - 1)) / regions.length, h: divHeight - divMargin.h * 2 };

            const yScale = d3.scaleLinear()
                .domain(d3.extent(data, d => d.value)).nice()
                .range([box.h, axisMargin]);

            const xScale = d3.scaleTime()
                .domain(d3.extent(data, d => d.year))
                .range([axisMargin, box.w]);

            for (let [i, region] of regions.entries()) {
                // console.log(rdata.filter(x => x.lc_sclas == region));
                let coord_x = divMargin.w + (box.w + boxMargin.w) * i;

                svg.insert('text')
                    .text(region)
                    .attr('class', 'chartTitle')
                    .attr('x', coord_x)
                    .attr('y', '1em');

                const noTextArea = rdata.filter((element) => !isNaN(element.value)).map(element => element.lc_sclas);
                // console.log(noTextArea)
                // console.log(rdata)

                if ( !noTextArea.includes(region) ) {
                    
                    svg.insert('text')
                        .text('데이터 없음')
                        .attr('class', 'noData')
                        .attr('x', coord_x + (box.w + boxMargin.w)*0.5 )
                        .attr('text-anchor', 'end')
                        .attr('y', (box.h + boxMargin.h)/2 )
                        .attr('dominant-baseline', 'central')
                        .style('fill', 'darkGrey');

                }

                let chart = svg.append('g')
                    .attr('transform', `translate(${coord_x}, ${divMargin.h})`);
                
                chart.append('path')
                    .datum(rdata.filter(x => x.lc_sclas == region))
                    .attr('fill', 'none')
                    .attr('stroke', tcolor)
                    .attr('stroke-width', lw)
                    .attr('marker-start', 'url(#dot)')
                    .attr('marker-mid', 'url(#dot)')
                    .attr('marker-end', 'url(#dot)')
                    .attr('stroke-linecap', 'round')
                    .attr('d', d3.line()
                        .defined(d => !isNaN(d.value))
                        .x(d => xScale(d.year))
                        .y(d => yScale(d.value)));
                
                chart.append('g')
                    .selectAll('text')
                    .data(rdata.filter(x => x.lc_sclas == region))
                    .join('text')
                    .text(d => !isNaN(d.value) ? parseInt(d.value * 10) / 10 : '')
                    // .attr('class', 'timeSeriesValue')
                    // .attr('fill', (d, i) => {
                    //         const val = 50 - (.25 + (i / 2) * .75) * 100;
                    //         const resultColor = shadeColor(tcolor, val);
                    //         return resultColor;
                    //     })
                    .attr('fill', tcolor)
                    .attr('x', d => xScale(d.year))
                    .attr('y', d => yScale(d.value))
                    .attr('dy', -10)
                    .attr('text-anchor', 'middle');
                    
                    // chart.append('g')
                    //     .attr('transform', `translate(${axisMargin}, 0)`)
                    //     .attr('id', 'y')
                    //     .attr('class', 'scale')
                    //     .call(d3.axisLeft(yScale)
                    //         .ticks(4)
                    //         .tickFormat(d3.format('.1f'))
                    //     );
                    
                chart.append('g')
                    .attr('transform', `translate(0, ${box.h + axisMargin})`)
                    .attr('id', 'x')
                    .attr('class', 'scale')
                    .call(d3.axisBottom(xScale)
                        .ticks(d3.timeYear.every(1))
                        .tickSize(0)
                        .tickPadding(5)
                    );
            }
        }
    };

    useEffect(() => {
        const svg = select(svgRef.current); // selection 객체

        svg.selectAll('*').remove() //이전 svg 제거

        if (data && data !== undefined) {
            svg
                .attr('color', grey)
                .append('defs')
                .append('marker')
                .attr('id', 'dot')
                .attr('markerUnits', 'userSpaceOnUse')
                .attr('viewBox', [0, 0, (ms + lw) * 2, (ms + lw) * 2])
                .attr('refX', ms + lw)
                .attr('refY', ms + lw)
                .attr('markerWidth', ms + lw)
                .attr('markerHeight', ms + lw)
                .append('circle')
                .attr('cx', ms + lw)
                .attr('cy', ms + lw)
                .attr('r', ms)
                .style('stroke', tcolor)
                .attr('stroke-width', lw * 3)
                .style('fill', tcolor);
            renderChartTs(data, svg, CoreAreaWidth);
        }
    }, [data, menu, CoreAreaWidth]); //data 변경시 렌더링함.

    if (isLoading) {
        return <div>Loading...</div>
    }
    if (isError) {
        return <div>Error! {error.message}</div>
    }

    return (
        <>
            <svg ref={svgRef}></svg>
        </>
    );
}

export default DataContainer;
